module.exports = __webpack_public_path__ + "img/zright1.228bb0cb.png";